import { render, staticRenderFns } from "./classificationmanage.vue?vue&type=template&id=8c7d95e4&scoped=true&"
import script from "./classificationmanage.vue?vue&type=script&lang=js&"
export * from "./classificationmanage.vue?vue&type=script&lang=js&"
import style0 from "./classificationmanage.vue?vue&type=style&index=0&id=8c7d95e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d95e4",
  null
  
)

export default component.exports